export const CellDataType = {
  STRING: 'String',
  MEMO: 'Memo',
  PHONE: 'Phone',
  MOBILE: 'Mobile',
  EMAIL: 'Email',
  NUMBER: 'Number',
  MULTI_LIST: 'Multi List',
  LIST: 'List',
  BOOLEAN: 'Boolean',
  CHECKBOX: 'Checkbox',
  LOOKUP: 'Lookup',
  DATE: 'Date',
  TIME: 'Time',
  DATE_TIME: 'Date Time',
  COMPANY_LIST: 'Company List',
}
